<logged-in-user-menu [forceNotifButton]="true">
    <a class="notifications-link" mat-menu-item routerLink="/billing/upgrade" *ngIf="tryProVisible" (click)="loggedInUserMenu.onItemClick()">
        <mat-icon svgIcon="star"></mat-icon>
        <span trans>Try Pro</span>
    </a>
</logged-in-user-menu>
